
import { BackButton } from "@/components/ui/back-button";

export const Header = () => {
  return (
    <div>
      <BackButton />
      
      <h1>Strategic Sparring Partner</h1>
      <p className="text-[22px] mb-12">
        Transform your product decisions and leadership approach through focused 1:1 strategic sessions. Get clarity, validate your thinking, and move forward with confidence.
      </p>
    </div>
  );
};
